import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import Breadcrumb from "../../components/Breadcrumb";
import ContactList from "../../components/misc/ContactList";
import MobileListActionBar from "../../components/mobile-action-bar/MobileListActionBar";
import Pagination from "../../components/Pagination";
import useResponsiveLimit from "../../composables/useResponsiveLimit";
import { useCustomerPropertiesStore } from "../../stores/customer_properties";

function CustomerProperty({ property }) {
  const contacts = property.contacts.map((link) => ({ ...link.contact, role: link.role }));

  return (
    <tr>
      <td className="w-10px align-middle">
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="product1" />
          <label className="form-check-label" htmlFor="product1"></label>
        </div>
      </td>
      <td>
        <Link to={`${property.id}/edit`} className="fw-bold">
          {property.number}
        </Link>
      </td>
      <td>
        {/*<Link*/}
        {/*  to={`${property.id}/details`}*/}
        {/*  className="text-dark text-decoration-none"*/}
        {/*>*/}
        {/*  {property.name}*/}
        {/*</Link>*/}
        {property.name}
      </td>
      <td>
        <Link to={`${property.id}/edit`} className="text-dark text-decoration-none">
          <ul className="list-group list-unstyled">
            {property.addresses.map((address) => (
              <li key={address.id}>
                <ul className="list-group list-unstyled">
                  {!!address.street && <li>{address.street}</li>}
                  {!!address.district && <li>{address.district}</li>}
                  {!!address.zip && (
                    <li>
                      {address.zip} {address.city} <i className="fa fa-map-pin" />
                    </li>
                  )}
                </ul>
              </li>
            ))}
          </ul>
        </Link>
      </td>
      <td>
        {property.customer && (
          <Link to={`/customers/${property.customer.id}/edit`}>{property.customer.number}</Link>
        )}
      </td>
      <td>
        <ContactList contacts={contacts} />
      </td>
    </tr>
  );
}

function CustomerProperties() {
  const { t } = useTranslation();
  const [queryParams, setQueryhParams] = useSearchParams();

  const { byIds, allIds, total, fetchSome } = useCustomerPropertiesStore(
    useShallow((state) => ({
      byIds: state.byIds,
      allIds: state.allIds,
      total: state.total,
      fetchSome: state.fetchSome,
    })),
  );

  const properties = allIds.map((id) => byIds[id]);

  const search = queryParams.get("q") || "";
  const defaultLimit = useResponsiveLimit(10);
  const limit = parseInt(queryParams.get("limit")) || defaultLimit;
  const page = parseInt(queryParams.get("page")) || 0;
  const offset = page * limit;

  useEffect(() => {
    fetchSome({ q: search, limit, offset });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page, limit]);

  const handleSearch = (e) => {
    setQueryhParams(`q=${e.target.value}`);
  };

  return (
    <div>
      <Breadcrumb items={[{ label: t("customers.properties.properties") }]}>
        {false && (
          <a href="#/" className="btn btn-red btn-rounded px-4 rounded-pill">
            <i className="fa fa-plus fa-lg me-2 ms-n2"></i> {t("menu.add")}
          </a>
        )}
      </Breadcrumb>

      <MobileListActionBar />

      {/*<div className="mb-3 mx-3 mx-md-0 d-sm-flex fw-bold">
        <div className="mt-sm-0 mt-2">
          <a href="#/" className="text-dark text-decoration-none">
            <i className="fa fa-download fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            {t("menu.export")}
          </a>
        </div>
        <div className="ms-sm-4 ps-sm-1 mt-sm-0 mt-2">
          <a href="#/" className="text-dark text-decoration-none">
            <i className="fa fa-upload fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            {t("menu.import")}
          </a>
        </div>
        <div className="ms-sm-4 ps-sm-1 mt-sm-0 mt-2 dropdown-toggle">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            className="text-dark text-decoration-none"
          >
            <i className="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            {t("menu.more")} <b className="caret"></b>
          </a>
          <div className="dropdown-menu">
            <a className="dropdown-item" href="#/">
              Action
            </a>
            <a className="dropdown-item" href="#/">
              Another action
            </a>
            <a className="dropdown-item" href="#/">
              Something else here
            </a>
            <div role="separator" className="dropdown-divider"></div>
            <a className="dropdown-item" href="#/">
              Separated link
            </a>
          </div>
        </div>
      </div>
      */}

      <div className="card border-0">
        <ul className="nav nav-tabs nav-tabs-v2 px-3">
          <li className="nav-item me-2">
            <a href="#allTab" className="nav-link active px-2" data-bs-toggle="tab">
              {t("menu.all")}
            </a>
          </li>
          <li className="nav-item me-2">
            <a href="#deletedTab" className="nav-link px-2" data-bs-toggle="tab">
              {t("menu.deleted")}
            </a>
          </li>
        </ul>
        <div className="tab-content p-3">
          <div className="tab-pane fade show active" id="allTab">
            <div className="input-group mb-3">
              <button
                className="btn btn-white dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {t("menu.filter")} <b className="caret"></b>
              </button>
              <div className="dropdown-menu">
                <a className="dropdown-item" href="#/">
                  Action
                </a>
                <a className="dropdown-item" href="#/">
                  Another action
                </a>
                <a className="dropdown-item" href="#/">
                  Something else here
                </a>
                <div role="separator" className="dropdown-divider"></div>
                <a className="dropdown-item" href="#/">
                  Separated link
                </a>
              </div>
              <div className="flex-fill position-relative">
                <div className="input-group">
                  <div
                    className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0"
                    style={{ zIndex: 1 }}
                  >
                    <i className="fa fa-search opacity-5"></i>
                  </div>
                  <input
                    type="text"
                    className="form-control ps-35px bg-light"
                    placeholder={t("menu.search") + "..."}
                    onChange={handleSearch}
                    value={search}
                  />
                </div>
              </div>
            </div>

            <div className="table-responsive mb-3">
              <table className="table table-hover table-panel text-nowrap align-middle mb-0">
                <thead>
                  <tr>
                    <th></th>
                    <th>{t("customers.properties.number")}</th>
                    <th>{t("customers.properties.name")}</th>
                    <th>{t("customers.properties.address")}</th>
                    <th>{t("customers.customer")}</th>
                    <th>{t("customers.properties.contact")}</th>
                  </tr>
                </thead>
                <tbody>
                  {properties.map((property) => (
                    <CustomerProperty key={property.id} property={property} />
                  ))}
                </tbody>
              </table>
            </div>

            <Pagination
              basePath="/customer_properties"
              page={page}
              limit={limit}
              total={total}
              queryParams={queryParams}
              label={t("customers.properties.properties")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerProperties;
